import { render, staticRenderFns } from "./Dial.vue?vue&type=template&id=af0ef85e&scoped=true&"
import script from "./Dial.vue?vue&type=script&lang=js&"
export * from "./Dial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0ef85e",
  null
  
)

export default component.exports